angular.module('skillBuilderSaaS')
    .directive('ngPatternRestrict', ['$log', function ($log) {
        'use strict';
        return {
            require: "ngModel",
            link: function (_scope, _element, attrs, ngModelCtrl) {
                var pattern = /[^.*]/;
                attrs.$observe("ngPatternRestrict", function (val) {
                    pattern = new RegExp(val.toString());
                });
                function fromUser(text) {
                    if (text) {
                        var transformedInput = text.replace(pattern, "");
                        if (transformedInput !== text) {
                            ngModelCtrl.$setViewValue(transformedInput);
                            ngModelCtrl.$render();
                        }
                        return transformedInput;
                    }
                    return null;
                }
                ngModelCtrl.$parsers.push(fromUser);
            }
        };
    }]);
